import { ChangeLogGroups } from '../enums';

const BASE_URL = 'assets/icons/change-log';

export const DEFAULT_ICON = `${BASE_URL}/updated.svg`;

export const CHANGE_LOG_ICON_MAP: Record<ChangeLogGroups, string> = {
  [ChangeLogGroups.FieldAdded]: `${BASE_URL}/added.svg`,
  [ChangeLogGroups.FieldEdited]: `${BASE_URL}/updated.svg`,
  [ChangeLogGroups.FieldRemoved]: `${BASE_URL}/removed.svg`,
  [ChangeLogGroups.FieldToggled]: `${BASE_URL}/updated.svg`,
  [ChangeLogGroups.FieldToggledWithOption]: `${BASE_URL}/updated.svg`,
  [ChangeLogGroups.FieldReordered]: `${BASE_URL}/updated.svg`,
  [ChangeLogGroups.FieldRequired]: `${BASE_URL}/updated.svg`,
  [ChangeLogGroups.FieldRevealed]: `${BASE_URL}/updated.svg`,
  [ChangeLogGroups.SensitiveConfigAdded]: `${BASE_URL}/added.svg`,
  [ChangeLogGroups.SensitiveConfigEdited]: `${BASE_URL}/updated.svg`,
  [ChangeLogGroups.SensitiveConfigRemoved]: `${BASE_URL}/updated.svg`,
  [ChangeLogGroups.SensitiveConfigRevealed]: `${BASE_URL}/updated.svg`,
  [ChangeLogGroups.UserRegistrationSuccess]: `${BASE_URL}/added.svg`,
  [ChangeLogGroups.StatusChanged]: `${BASE_URL}/updated.svg`,
  [ChangeLogGroups.FieldEditedFor]: `${BASE_URL}/updated.svg`,
  [ChangeLogGroups.FieldAddedFor]: `${BASE_URL}/added.svg`,
  [ChangeLogGroups.FormBuilderFieldAdded]: `${BASE_URL}/added.svg`,
  [ChangeLogGroups.FormBuilderFieldPositionChanged]: `${BASE_URL}/updated.svg`,
  [ChangeLogGroups.FormBuilderFieldRequiredToggled]: `${BASE_URL}/updated.svg`,
  [ChangeLogGroups.FormBuilderFieldRemoved]: `${BASE_URL}/removed.svg`,
  [ChangeLogGroups.FieldEditedWithOption]: `${BASE_URL}/updated.svg`,
  [ChangeLogGroups.UserStatusChanged]: `${BASE_URL}/updated.svg`,
  [ChangeLogGroups.FieldAddedForProviderWithMethods]: `${BASE_URL}/added.svg`,
  [ChangeLogGroups.SensitiveConfigAddedForProviderWithMethods]: `${BASE_URL}/added.svg`,
  [ChangeLogGroups.FieldEditedForProviderWithMethods]: `${BASE_URL}/updated.svg`,
  [ChangeLogGroups.FieldRemovedForPoviderWithMethods]: `${BASE_URL}/removed.svg`,
  [ChangeLogGroups.SensitiveConfigEditedForProviderWithMethods]: `${BASE_URL}/updated.svg`,
  [ChangeLogGroups.SensitiveConfigRemovedForProviderWithMethods]: `${BASE_URL}/removed.svg`,
  [ChangeLogGroups.MultipleChanged]: `${BASE_URL}/updated.svg`,
  [ChangeLogGroups.LicenseAdded]: `${BASE_URL}/added.svg`,
  [ChangeLogGroups.LicenseUpdated]: `${BASE_URL}/updated.svg`,
  [ChangeLogGroups.LicenseRemoved]: `${BASE_URL}/removed.svg`,
  [ChangeLogGroups.ContactChannelAdded]: `${BASE_URL}/added.svg`,
  [ChangeLogGroups.ContactChannelsLinkUpdated]: `${BASE_URL}/updated.svg`,
  [ChangeLogGroups.OperatorRegionalSettingsChanged]: `${BASE_URL}/updated.svg`,
  [ChangeLogGroups.OperatorRegionalSettingsListChanged]: `${BASE_URL}/updated.svg`,
  [ChangeLogGroups.OperatorPauseStatusChanged]: `${BASE_URL}/updated.svg`,
};
